import { DocuParserPanel } from "./DocuParserPanel";

interface DocuParserModuleProps {
  readonly onBack?: () => void;
  // Accepted (not used) for prop-shape parity with how TaskPane renders every
  // module tile — DeckorateModule does the same. There's no connection to
  // configure: host-direct means no per-connector credentials/settings.
  readonly onOpenSettings?: () => void;
}

/**
 * No connect gate here — DocuParser has no individual login/logout of its
 * own. It's host-direct like Deckorate: it authenticates with the add-in's
 * own AIVA session (see hooks/useDocuparserHttp.ts), not a per-connector
 * Cognito adapter.
 */
export function DocuParserModule({ onBack }: Readonly<DocuParserModuleProps> = {}) {
  return <DocuParserPanel onBack={onBack} />;
}
